/**
 *  @class
 *  @function BeforeAfter
 */
if (!customElements.get('before-after')) {
	class BeforeAfter extends HTMLElement {
		constructor() {
			super();
			this.divider = this.querySelector('.before-after__divider');

			this.setupDividerDrag();
		}

		setupDividerDrag() {
			const divider = this.divider;
			const container = this;
			const orientation = this.dataset.orientation === 'vertical' ? 'vertical' : 'horizontal';

			const getPercent = (clientCoord) => {
				if (orientation === 'vertical') {
					return ((clientCoord - container.getBoundingClientRect().top) / container.clientHeight) * 100;
				}
				return ((clientCoord - container.getBoundingClientRect().left) / container.clientWidth) * 100;
			};

			const handleSlide = (e) => {
				const coord = orientation === 'vertical' ? e.clientY : e.clientX;
				let percent = getPercent(coord);
				if (percent < 0) {
					percent = 0;
					divider.classList.remove('grab');
					container.removeEventListener('mousemove', handleSlide);
				} else if (percent > 100) {
					percent = 100;
					divider.classList.remove('grab');
					container.removeEventListener('mousemove', handleSlide);
				}
				this.style.setProperty('--percent', percent + '%');
			};

			const handleTouchSlide = (e) => {
				e.preventDefault();
				const touch = e.targetTouches[0];
				const coord = orientation === 'vertical' ? touch.clientY : touch.clientX;
				let percent = getPercent(coord);
				if (percent < 0) {
					percent = 0;
					divider.classList.remove('grab');
					container.removeEventListener('touchmove', handleTouchSlide);
				} else if (percent > 100) {
					percent = 100;
					divider.classList.remove('grab');
					container.removeEventListener('touchmove', handleTouchSlide);
				}
				this.style.setProperty('--percent', percent + '%');
			};

			this.divider.addEventListener('mousedown', () => {
				this.divider.classList.add('grab');
				this.addEventListener('mousemove', handleSlide);
			});

			this.divider.addEventListener('mouseup', () => {
				this.divider.classList.remove('grab');
				this.removeEventListener('mousemove', handleSlide);
			});

			this.divider.addEventListener('touchstart', () => {
				this.divider.classList.add('grab');
				this.addEventListener('touchmove', handleTouchSlide, { passive: false });
			}, { passive: false });

			this.divider.addEventListener('touchend', () => {
				this.divider.classList.remove('grab');
				this.removeEventListener('touchmove', handleTouchSlide);
			});
		}
	}
	customElements.define('before-after', BeforeAfter);
}
